export default "__VITE_ASSET__CZn1EtH8__"